import React, { useEffect, useState } from 'react'
import { getCourseLessonLevelReports, getOverviewTexts, saveOverviewTexts } from '../../../lib/studentcourselessonreport'
import { ReportCard, ToastNotification, OverviewTextarea, UpdateButton } from './CourseReportComponents'
import { getHeaderClass, sortLevels } from './CourseReportUtils'
import style from './CourseReportStyles.module.css'

const OVERVIEW_KEY = 'clevelTest2'

export const CourseLessonLevelReport = ({ studentId, isStudent = false }) => {
	const [data, setData] = useState([])
	const [levels, setLevels] = useState([])
	const [overview, setOverview] = useState({})
	const [showToast, setShowToast] = useState(false)
	const [toastMessage, setToastMessage] = useState('')

	useEffect(() => {
		loadData()
	}, [studentId])

	const loadData = async () => {
		const raw = await getCourseLessonLevelReports(studentId)
		const sorted = raw.sort((a, b) => a.courseyear - b.courseyear)
		setData(sorted)

		// LEVELS: courseyear ve studentId dışındaki alanlar
		const dynamicLevels = new Set()
		sorted.forEach((row) => {
			Object.keys(row).forEach((key) => {
				if (!['courseyear', 'studentId', 'Total'].includes(key)) {
					dynamicLevels.add(key)
				}
			})
		})
		setLevels(sortLevels([...dynamicLevels]))

		const overviewRaw = await getOverviewTexts(studentId)
		const overviewMap = {}
		overviewRaw.forEach((item) => {
			overviewMap[item.type] = item.desc
		})
		setOverview(overviewMap)
	}

	const handleOverviewChange = (value) => {
		setOverview((prev) => ({ ...prev, [OVERVIEW_KEY]: value }))
	}

	const handleUpdate = async () => {
		await saveOverviewTexts(studentId, { [OVERVIEW_KEY]: overview[OVERVIEW_KEY] || '' })
		setShowToast(true)
		setToastMessage('Update successful!')
		setTimeout(() => setShowToast(false), 3000)
		loadData()
	}

	const getRowTotal = (row) => levels.reduce((sum, lvl) => sum + (row[lvl] || 0), 0)

	return (
		<ReportCard title="Course Load">
			<ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />

			<table className="table table-bordered text-center">
				<thead>
					<tr>
						<th style={{ width: '150px' }}>Grade Level</th>
						<th>Total</th>
						{levels.map((lvl) => (
							<th key={lvl} className={style[getHeaderClass(lvl)]}>
								{lvl}
							</th>
						))}
						<th style={{ width: '400px' }}>Overview</th>
					</tr>
				</thead>
				<tbody>
					{data.map((row, index) => (
						<tr key={row.courseyear}>
							<td>{`Grade-${row.courseyear}`}</td>
							<td className={style.totalCell}>{row.Total ?? getRowTotal(row)}</td>
							{levels.map((lvl) => (
								<td key={lvl} className={row[lvl] > 0 ? style[getHeaderClass(lvl)] : ''}>
									{row[lvl] ?? 0}
								</td>
							))}
							{index === 0 && (
								<td rowSpan={data.length + 1} className={style.overviewCell}>
									<OverviewTextarea
										value={overview[OVERVIEW_KEY] || ''}
										onChange={handleOverviewChange}
										rows={data.length * 2}
										isStudent={isStudent}
										className="h-100"
									/>
								</td>
							)}
						</tr>
					))}
					<tr>
						<td>
							<strong>TOTAL</strong>
						</td>
						<td className={style.totalCell}>{data.reduce((sum, row) => sum + (row.Total ?? getRowTotal(row)), 0)}</td>
						{levels.map((lvl) => {
							const total = data.reduce((acc, row) => acc + (row[lvl] || 0), 0)
							return (
								<td key={lvl} className={(total > 0 ? style[getHeaderClass(lvl)] : '') + ' fw-bold'}>
									{total}
								</td>
							)
						})}
					</tr>
				</tbody>
			</table>

			<UpdateButton onClick={handleUpdate} isStudent={isStudent} />
		</ReportCard>
	)
}
